module.exports = __webpack_public_path__ + "img/720x900-soru-4.cfd0ab60.jpg";